export default {
  label: {
    title: 'Busca',
    search: 'Busca textual en publicaciones',
    tags: 'Seleccione las etiquetas',
    send: 'Enviar',
    clear: 'Limpiar',
    requiredValue: 'Valor obligatorio',
    trashLabel: 'Limpiar filtro',
    closeLabel: 'Cerrar información',
    filterLabel: 'Aplicar filtro',
    tooltip: {
      filterButton: 'Filtros',
    },
    rule: 'Debe contener al menos dos caracteres',
  },

  titles: {
    postedAt: 'Fecha del documento: ',
    tags: 'Clasificaciones: ',
    text: 'Texto del documento: ',
  },

  infoLabel: 'Información del formulario',
  closeLabel: 'Cerrar información',
  filter: 'Filtro',
  noPosts: 'Ningún resultado encontrado para el filtro seleccionado',
  viewLabel: 'Ver documento',
  searchTip: 'Utilice operadores booleanos AND(y), OR(o), NOT(no) para combinar varios términos. Para expresiones, utilice texto libre. Para expresiones utilice comillas("").</br>Los paréntesis pueden ser utilizados para agrupar expresiones. Ej: (coche OR camiones) AND rojo.',

  faq: {
    title: '¿Qué es?',
    description: 'Formulario para búsqueda y visualización de los documentos deseados de acuerdo con el texto escrito por el usuario.',
  },
  faq2: {
    title: '¿Cómo utilizar?',
    description: 'Ingrese la palabra o frase deseada y presione el botón buscar.',
  },
  faq3: {
    title: '¿Cómo redefinir el formulario?',
    description: 'Para limpiar el formulario, haga clic en el botón limpiar. Cuando una importación se realiza con éxito, el formulario se restablece automáticamente.',
  },
  faq4: {
    title: '¿Qué sucede si la importación falla?',
    description: 'Si una importación falla, se mostrará un mensaje de error. Restablezca el formulario, verifique la información e intente nuevamente.',
  },
};
